import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Radio from '@material-ui/core/Radio';

const BobRadioButton = withStyles({
    root: {
        color:       '#323232',
        '&$checked': {
            color: '#000000',
        }
    },
    checked: {},
})((props) => <Radio style={{ transform: 'scale(1.3)' }}color="default" {...props} />);

export default BobRadioButton;
